import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { VoucherService } from '@app/api/voucher.service';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import moment from 'moment';
import { ModalVoucherComponent } from './component/modal-voucher/modal-voucher.component';

@Component({
  selector: 'meu-manage-vouchers',
  templateUrl: './manage-vouchers.component.html',
  styleUrls: ['./manage-vouchers.component.scss'],
})
export class ManageVouchersComponent implements OnInit {
  lstVouchers: any[] = [];
  displayedColumns: string[] = ['Index', 'code', 'value', 'expiry', 'note', 'is_used', 'Actions'];
  total: any;
  pageSize = 10;
  pageIndex = 1;
  filter: any = '';
  today = Date.now();

  pageSizeOptions: number[] = [5, 10, 20, 100];

  constructor(
    public dialog: MatDialog,
    private toastr: ToastrService,
    private voucherService: VoucherService,
    private layoutUtilsService: LayoutUtilsService
  ) {}

  ngOnInit() {
    this.getListVoucher();
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getListVoucher();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1;
    this.getListVoucher();
  }

  objectSort(a, b) {
    if (a.last_nom < b.last_nom) {
      return -1;
    }
    if (a.last_nom > b.last_nom) {
      return 1;
    }
    return 0;
  }

  getListVoucher() {
    this.voucherService
      .apiVouchersGet(this.filter, 'is_used', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.total = res.data.total;
          // this.pageIndex = res.data.pageIndex;
          // this.pageSize = res.data.pagesize;

          res.data.collection.forEach((element) => {
            if (
              Date.parse(moment(element.expiry).format('YYYY-MM-DD')) <
              Date.parse(moment(this.today).format('YYYY-MM-DD'))
            ) {
              element.expired = true;
            } else {
              element.expired = false;
            }
          });

          //   res.data.collection.sort((a, b) =>
          //     a.expired > b.expired ? 1 : b.expired > a.expired ? -1 : 0
          //   );

          this.lstVouchers = [...res.data.collection];
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  removeVoucher(voucherId) {
    const title = 'Xóa mã giảm giá';
    const description = 'Bạn có chắc chắn muốn xóa mã giảm giá này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.voucherService.apiVouchersIdDelete(voucherId).subscribe((res) => {
          if (res.success) {
            this.getListVoucher();
            this.toastr.success('Thao tác thành công');
          } else {
            this.toastr.error(res.message, 'Thao tác xóa không thành công');
          }
        });
      }
    });
  }

  openModal() {
    const dialogRef = this.dialog.open(ModalVoucherComponent, {
      width: '650px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getListVoucher();
    });
  }
}
